
        <div class="jui-menu-submenu-title"
            [style.paddingLeft.px]="(menuComponent.mode === 'inline') ? (level*padding) : null"
            (mouseenter)="onMouseEnterEvent($event)"
            (mouseleave)="onMouseLeaveEvent($event)"
            (click)="clickSubMenuTitle()">
            <ng-content select="[title]"></ng-content>
            <ng-template [ngIf]="isShowMoreIcon">
                <i *ngIf="menuComponent.mode === 'vertical'"
                    [class.active]="isOpen"
                    class="iconfont icon-jui-right2 icon-more"></i>
                <i *ngIf="menuComponent.mode === 'horizontal' || menuComponent.mode === 'inline'"
                    [class.active]="isOpen"
                    class="iconfont icon-jui-down2 icon-more"></i>
            </ng-template>
        </div>
        <ul class="jui-menu jui-menu-submenu-sub"
            *ngIf="isOpen"
            [@fadeAnimation]
            [@expandAnimation]="expandState"
            [class.jui-menu-vertical]="menuComponent.mode!=='inline'"
            [class.jui-menu-inline]="menuComponent.mode==='inline'"
            (mouseenter)="onMouseEnterEvent($event)"
            (mouseleave)="onMouseLeaveEvent($event)"
            (click)="clickSubMenuDropDown()">
            <ng-content></ng-content>
        </ul>
    